import ProfileNavigationLink from "components/molecules/ProfileNavigationLink";
import LogoutBlock from "components/molecules/LogoutBlock";
import {
  PROFILE_NAVIGATION,
  PROFILE_NAVIGATION_ENUMS,
} from "constants/navigation/profile";
import { useSelector } from "react-redux";
import LoyaltyButton from "components/atoms/LoyaltyButton";
import CoinFestSidebar from "../../molecules/CoinFestSidebar/CoinFestSidebar";
import ProfileWidgetContainer from "../../../containers/organisms/ProfileWidgetContainer";
import "./styles.sass";
import * as userSelector from "../../../redux/user/selectors";

type ProfileSidebarProps = {
  navNotifications: PROFILE_NAVIGATION_ENUMS[];
  enabledReferral: boolean;
  showLoyaltyContent?: boolean;
};

const ProfileSidebar = ({
  navNotifications,
  enabledReferral,
  showLoyaltyContent = false,
}: ProfileSidebarProps) => {
  const filteredNavigation = PROFILE_NAVIGATION.filter(
    (el) => enabledReferral || el.id !== PROFILE_NAVIGATION_ENUMS.INVITE,
  );
  const hasFirstDeposit = useSelector(userSelector.hasFirstDeposit);
  const currency = useSelector(userSelector.currency);
  const isAvailableGeo =
    currency?.isoCode === "BDT" ||
    currency?.isoCode === "TRY" ||
    currency?.isoCode === "AZN" ||
    currency?.isoCode === "INR" ||
    currency?.isoCode === "KZT" ||
    currency?.isoCode === "UZS" ||
    currency?.isoCode === "PKR";

  return (
    <div className="ProfileSidebar">
      {`${import.meta.env.VITE_APP_PROJECT_NAME}` === "glory" &&
        hasFirstDeposit &&
        isAvailableGeo && <CoinFestSidebar isSidebarOpen />}
      <div className="ProfileSidebar__balance">
        <div className="ProfileSidebar__balance-card">
          {/* <BalanceInfoContainer type="mono" /> */}
          {showLoyaltyContent ? <ProfileWidgetContainer /> : null}
        </div>
      </div>
      <div className="ProfileSidebar__loyalty_btn">
        {showLoyaltyContent ? <LoyaltyButton /> : null}
      </div>
      <div className="ProfileSidebar__content">
        <div className="ProfileSidebar__navigation">
          {filteredNavigation.map((item) => (
            <div className="ProfileSidebar__navigation_item" key={item.id}>
              <ProfileNavigationLink
                key={item.id}
                name={item.name}
                icon={item.icon}
                url={item.url}
                id={item.id}
                hasNotify={navNotifications.includes(item.id)}
                htmlId={item.htmlId}
              />
            </div>
          ))}
          <div className="ProfileSidebar__navigation_item logout">
            <LogoutBlock />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSidebar;
